/* eslint-disable max-len */
import React from 'react';

const getViewBox = (name) => {
  switch (name) {
    default:
      return '0 0 24 24';
  }
};

const getPath = (name, props) => {
  const { fill, strokeWidth, bgfill } = props;
  switch (name) {
    case 'icon-dashboard':
      return (
        <>
          <path
            d='M4 20.667h5.333V16L10 14.667l1.333-1.334h1.334L14 14l.667 2v4.667H20l.667-9.334-9.334-8-7.333 8v9.334Z'
            fill={bgfill}
          />
          <path
            clipRule='evenodd'
            d='M9.5 20.5V16a2.5 2.5 0 0 1 2.5-2.5v0a2.5 2.5 0 0 1 2.5 2.5v4.5H20v-8.586a2 2 0 0 0-.586-1.414l-6.707-6.707a.999.999 0 0 0-1.414 0L4.586 10.5A2 2 0 0 0 4 11.914V20.5h5.5Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-email':
      return (
        <>
          <rect
            x={3}
            y={5}
            width={18}
            height={14}
            rx={3}
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='m7.5 9.75 2.925 1.804a3 3 0 0 0 3.15 0L16.5 9.75'
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-user':
      return (
        <>
          <path d='M15.332 4.003v6.664s3.332-.666 3.332-3.332c0-2.5-2-3.332-3.332-3.332Z' fill={bgfill} />
          <path
            d='M15.214 10.429a3.336 3.336 0 0 0 3.215-3.312A3.167 3.167 0 0 0 15.214 4'
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M9.428 10.429a3.336 3.336 0 0 0 3.215-3.312A3.167 3.167 0 0 0 9.428 4a3.167 3.167 0 0 0-3.214 3.117 3.335 3.335 0 0 0 3.214 3.312Z'
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='m3.337 16.665-.666 3.332h13.327v-3.332l-1.332-1.333-1.333-.666-2-.667H4.67l-1.333 2.666Z'
            fill={bgfill}
          />
          <path
            d='M16 20v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2'
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path d='M20.663 15.998 17.998 14v5.998h2.665v-3.999Z' fill={bgfill} />
          <path
            d='M21 20v-3a3 3 0 0 0-3-3'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-account':
      return (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M19 21H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2Z'
            fill={bgfill}
          />
          <path
            clipRule='evenodd'
            d='M19 21H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M16 21V6a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v15'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-deals':
      return (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M18.367 5.633a9.003 9.003 0 0 1 0 12.734 9.003 9.003 0 0 1-12.734 0 9.003 9.003 0 0 1 0-12.734 9.003 9.003 0 0 1 12.734 0'
            fill={bgfill}
          />
          <path
            d='M18.367 5.633a9.003 9.003 0 0 1 0 12.734 9.003 9.003 0 0 1-12.734 0 9.003 9.003 0 0 1 0-12.734 9.003 9.003 0 0 1 12.734 0M9.75 16.002h4.501M8.624 12.5h6.753M7.498 8.999h9.004'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-bookmark':
      return (
        <>
          <path
            d='M15 9H9m10-2v12.998a1 1 0 0 1-1.581.814L12 16.942l-5.419 3.87A1 1 0 0 1 5 19.998V7a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-idea':
      return (
        <>
          <path
            d='m18.364 4.636-.636.636M21 11h-.9M3.9 11H3m3.272-5.728-.636-.636M12 2.9V2M9.5 21h5M12 6.5a4.981 4.981 0 0 0-3 8.972V17a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1.528A4.981 4.981 0 0 0 12 6.5Z'
            stroke={fill}
            fill='none'
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-other':
      return (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M10 12H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2ZM18.5 20h-3a1.5 1.5 0 0 1-1.5-1.5v-3a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5ZM19.5 11h-3A1.5 1.5 0 0 1 15 9.5v-3A1.5 1.5 0 0 1 16.5 5h3A1.5 1.5 0 0 1 21 6.5v3a1.5 1.5 0 0 1-1.5 1.5ZM9.5 21h-3A1.5 1.5 0 0 1 5 19.5v-3A1.5 1.5 0 0 1 6.5 15h3a1.5 1.5 0 0 1 1.5 1.5v3A1.5 1.5 0 0 1 9.5 21Z'
            fill={bgfill}
            stroke='#fff'
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-leads':
      return (
        <path
          d='M16.502 18.003a2.384 2.384 0 0 0-2.21-1.501H9.708a2.375 2.375 0 0 0-2.209 1.5M4.78 5.998v-1a2 2 0 0 1 2-2h10.44a2 2 0 0 1 2.001 2v1m-.263 15.007H5.043a2 2 0 0 1-2-2.001V7.998a2 2 0 0 1 2-2h13.914a2 2 0 0 1 2 2v11.005a2 2 0 0 1-2 2ZM12 8.999A2.5 2.5 0 1 1 12 14 2.5 2.5 0 0 1 12 9Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-task':
      return (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M16.002 4.997h2a2 2 0 0 1 2.002 2v12.006a2 2 0 0 1-2.001 2H5.998a2 2 0 0 1-2.001-2V6.998a2 2 0 0 1 2-2h2.001'
            fill={bgfill}
          />
          <path
            d='M16.002 4.997h2a2 2 0 0 1 2.002 2v12.006a2 2 0 0 1-2.001 2H5.998a2 2 0 0 1-2.001-2V6.998a2 2 0 0 1 2-2h2.001'
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <rect
            x={7.998}
            y={2.996}
            width={8.003}
            height={4.002}
            rx={1.333}
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='m14.234 12.852-2.79 2.79-1.68-1.672'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-more':
      return (
        <path
          d='M18.503 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M12.5 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M6.498 12a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-add-plus':
      return (
        <path
          d='M12 8v8m4-4H8m4 9a9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-infographic':
      return (
        <>
          <path d='M16 9V7h-2' stroke={fill} strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round' />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M5.778 3h12.444C19.204 3 20 3.895 20 5v14c0 1.105-.796 2-1.778 2H5.778C4.796 21 4 20.105 4 19V5c0-1.105.796-2 1.778-2Z'
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M8 13.5h8M8 17h4M16 7l-3 3-2.714-2L8 10'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-customize':
      return (
        <>
          <path
            d='M5 6V3m0 18V10m7 4V3m0 18v-3m7-12V3m0 18V10M6.414 6.586a2 2 0 1 1-2.828 2.828 2 2 0 0 1 2.828-2.828Zm7 8a2 2 0 1 1-2.828 2.828 2 2 0 0 1 2.828-2.828Zm7-8a2 2 0 1 1-2.828 2.828 2 2 0 0 1 2.828-2.828Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-list':
      return (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M10.374 12.005a.75.75 0 0 1 .75-.75h4.178a.75.75 0 1 1 0 1.5h-4.178a.75.75 0 0 1-.75-.75ZM10.374 15.996a.75.75 0 0 1 .751-.75l6.003.006a.75.75 0 1 1-.002 1.5l-6.002-.005a.75.75 0 0 1-.75-.751Z'
            fill={fill}
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M2.246 4.996a2.75 2.75 0 0 1 2.75-2.75h14.008a2.75 2.75 0 0 1 2.75 2.75v14.008a2.75 2.75 0 0 1-2.75 2.75H4.996a2.75 2.75 0 0 1-2.75-2.75V4.996Zm2.75-1.25c-.69 0-1.25.56-1.25 1.25v14.008c0 .69.56 1.25 1.25 1.25h14.008c.69 0 1.25-.56 1.25-1.25V4.996c0-.69-.56-1.25-1.25-1.25H4.996Z'
            fill={fill}
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M10.374 7.993a.75.75 0 0 1 .75-.75h6.003a.75.75 0 0 1 0 1.5h-6.002a.75.75 0 0 1-.75-.75ZM7.117 6.998a1 1 0 1 1 .007 2 1 1 0 0 1-.007-2ZM7.117 11a1 1 0 1 1 .013 1.998A1 1 0 0 1 7.117 11ZM7.117 15a1 1 0 1 1 .013 1.998A1 1 0 0 1 7.117 15Z'
            fill={fill}
          />
        </>
      );
    case 'icon-create-meeting':
      return (
        <>
          <path
            d='M6.999 10.75a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5M6.999 14.75a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5M10.75 11.001a.25.25 0 1 0 .5-.002.25.25 0 0 0-.5.002'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M15 3v2M7 3v2M3 8h16m0 2V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h6m6.293 1.707 4.414-4.414a.999.999 0 0 0 0-1.414l-1.586-1.586a.999.999 0 0 0-1.414 0l-4.414 4.414a1 1 0 0 0-.293.707V21h2.586a1 1 0 0 0 .707-.293Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-invoice':
      return (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M4 4.5v15a1 1 0 0 0 1.448.894l.77-.386a.998.998 0 0 1 .895 0l1.773.886a.998.998 0 0 0 .894 0l1.773-.886a.998.998 0 0 1 .894 0l1.773.886a1 1 0 0 0 .895 0l1.77-.886a1 1 0 0 1 .896 0l.772.386A1 1 0 0 0 20 19.5v-15a1 1 0 0 0-1.448-.894l-.771.386a.998.998 0 0 1-.894 0l-1.773-.886a.998.998 0 0 0-.894 0l-1.773.886c-.281.14-.612.14-.893 0L9.78 3.106a1 1 0 0 0-.895 0l-1.771.886a1 1 0 0 1-.895 0l-.773-.386A1 1 0 0 0 4 4.5Z'
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M8 16h5M15.875 16.125a.125.125 0 1 0 0-.25.125.125 0 0 0 0 .25M8 12h5M15.875 12.125a.125.125 0 1 0 0-.25.125.125 0 0 0 0 .25M8 8h5M15.875 8.125a.125.125 0 1 0 0-.25.125.125 0 0 0 0 .25'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-webcam':
      return (
        <>
          <path d='M18 21H6' stroke={fill} strokeWidth={strokeWidth} strokeLinecap='round' strokeLinejoin='round' />
          <circle
            cx={12}
            cy={10}
            r={8}
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M13.5 5.5h-3M14 21H6M16 17v1c0 1.657.672 3 1.5 3M8 17v1c0 1.657-.672 3-1.5 3M16 17v-.07M8 17v-.07'
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <circle
            cx={12}
            cy={10.5}
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
            r={2.5}
          />
        </>
      );
    case 'icon-goal':
      return (
        <>
          <path
            d='m14.04 9.96-2.51 2.51'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M14 5.997V10h4.002l4.002-4.002-2.668-1.333-1.334-2.668-4.001 4.001Z'
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M11 3.972A8.524 8.524 0 1 0 20.03 13'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M16.212 13A4.727 4.727 0 1 1 11 7.788'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-inbox':
      return (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M9 6H7.386a2 2 0 0 0-1.873 1.298L3.127 13.66a2.01 2.01 0 0 0-.127.703V18a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3.637a2 2 0 0 0-.127-.702l-2.386-6.363A2 2 0 0 0 16.614 6H15'
            fill={bgfill}
          />
          <path
            d='M9 6H7.386a2 2 0 0 0-1.873 1.298L3.127 13.66a2.01 2.01 0 0 0-.127.703V18a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3.637a2 2 0 0 0-.127-.702l-2.386-6.363A2 2 0 0 0 16.614 6H9Z'
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M3.034 14h4.348c.379 0 .725.214.894.553l.447.894c.17.339.516.553.895.553h4.764a.998.998 0 0 0 .894-.553l.447-.894c.17-.339.516-.553.895-.553h4.348'
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-star':
      return (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M7.875 21.068a1.5 1.5 0 0 1-2.172-1.593l.809-4.639-3.407-3.265a1.5 1.5 0 0 1 .827-2.572l4.73-.676L10.8 4.062a1.5 1.5 0 0 1 2.689 0l2.136 4.26 4.73.677a1.5 1.5 0 0 1 .828 2.572l-3.407 3.265.809 4.64a1.5 1.5 0 0 1-2.172 1.593l-4.269-2.206-4.268 2.205Z'
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-save':
      return (
        <>
          <path
            d='M20.993 14V7.828a2 2 0 0 0-.586-1.414l-2.828-2.828A2.003 2.003 0 0 0 16.164 3H5.007a2 2 0 0 0-2 2.015l.104 14a2 2 0 0 0 2 1.985H13m2.993-18v3.909a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V3M7 21v-7.714C7 12.576 7.576 12 8.286 12h7.429c.709 0 1.285.576 1.285 1.286V14m4 4-3 3-2-2'
            stroke={fill}
            fill='none'
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-merge':
      return (
        <>
          <path
            d='M6.498 7.998a2.501 2.501 0 1 0 0-5.002 2.501 2.501 0 0 0 0 5.002Zm0 0v8.004m0-8.004A5.002 5.002 0 0 0 11.5 13H15m-8.503 3.002a2.501 2.501 0 1 0 0 5.002 2.501 2.501 0 0 0 0-5.002ZM15 13a2.501 2.501 0 1 0 5.002 0 2.501 2.501 0 0 0-5.002 0Z'
            stroke={fill}
            fill='none'
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-user-minus-delete':
      return (
        <>
          <circle
            cx={16.75}
            cy={17.75}
            r={4.25}
            stroke={fill}
            fill='none'
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M10 15H7a4 4 0 0 0-4 4v1'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <circle
            cx={11}
            cy={7}
            r={4}
            stroke={fill}
            fill='none'
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M18 17.75h-2.5'
            stroke={fill}
            fill='none'
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-copy':
      return (
        <path
          d='M6.998 17.002H4.997a2 2 0 0 1-2-2V4.996a2 2 0 0 1 2-2h10.004a2 2 0 0 1 2.001 2v2M8.998 21.005h10.006a2 2 0 0 0 2-2V8.998a2 2 0 0 0-2-2H8.998a2 2 0 0 0-2 2v10.006a2 2 0 0 0 2 2Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-check':
      return (
        <path
          d='M20 6 9 17l-5-5'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-share-link':
      return (
        <path
          d='M19 9V5h-4M13 11l6-6M20 13v2a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V9a5 5 0 0 1 5-5h2'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-phone':
      return (
        <path
          clipRule='evenodd'
          d='M10.856 13.144a12.634 12.634 0 0 1-2.638-3.809.749.749 0 0 1 .166-.827l.819-.818c.671-.671.671-1.62.085-2.206L8.114 4.31a2 2 0 0 0-2.828 0l-.652.652c-.741.741-1.05 1.81-.85 2.87.494 2.613 2.012 5.474 4.461 7.923 2.449 2.449 5.31 3.967 7.923 4.461 1.06.2 2.129-.109 2.87-.85l.651-.651a2 2 0 0 0 0-2.828l-1.173-1.173a1.5 1.5 0 0 0-2.121 0l-.903.904a.749.749 0 0 1-.827.166 12.66 12.66 0 0 1-3.809-2.64Z'
          fill={bgfill}
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-not-answered':
      return (
        <path
          clipRule='evenodd'
          d='M18.434 16H20a2 2 0 0 0 2-2v-1.014c0-1.029-.528-1.986-1.402-2.583C18.441 8.932 15.401 8 12 8c-3.401 0-6.441.932-8.598 2.404C2.528 11.001 2 11.958 2 12.986V14a2 2 0 0 0 2 2h1.566a1.5 1.5 0 0 0 1.5-1.5v-1.363c0-.307.181-.591.467-.702a12.395 12.395 0 0 1 4.467-.81c1.621 0 3.141.296 4.467.81a.749.749 0 0 1 .467.702V14.5a1.5 1.5 0 0 0 1.5 1.5v0Z'
          stroke={fill}
          fill='none'
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-food':
      return (
        <path
          d='M8.999 6.998a3.001 3.001 0 1 1 6.002 0 2.122 2.122 0 0 1 3.002 0c.653.647.81 1.643.39 2.46M8.999 13A3.001 3.001 0 0 1 12 10m0 0a3.001 3.001 0 0 1 3.001 3M12 10a3.002 3.002 0 0 0-5.92-.706.475.475 0 0 1-.664.319 1.758 1.758 0 0 0-1.905 2.873l.681.68m15.794.103a4.764 4.764 0 0 0 .916-2.802v-.6a.6.6 0 0 0-.6-.6h-.6A4.797 4.797 0 0 0 15.029 13m4.774 5.603a6.002 6.002 0 0 1-4.802 2.4H9a6.002 6.002 0 0 1-6.003-6.002 2 2 0 0 1 2.001-2h14.006a2 2 0 0 1 2 2 6.002 6.002 0 0 1-1.2 3.602Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-flag':
      return (
        <path
          d='M6 12h14l-2-4.5L20 3H6v17m2 0H4'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-note':
      return (
        <>
          <path
            d='M11.125 12.005h4.177M11.125 15.997l6.002.005'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <rect
            x={2.996}
            y={2.996}
            width={18.008}
            height={18.008}
            rx={2}
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M11.125 7.993h6.002M7.122 7.748a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5M7.122 11.75a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5M7.122 15.752a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-attachment':
      return (
        <path
          d='m13.633 8.376-5.486 5.486a2.116 2.116 0 0 0 0 2.992v0a2.116 2.116 0 0 0 2.992 0l7.232-7.232a3.879 3.879 0 0 0 0-5.486v0a3.879 3.879 0 0 0-5.486 0l-7.232 7.232a5.642 5.642 0 0 0 0 7.98v0a5.642 5.642 0 0 0 7.98 0l4.389-4.389'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-share':
      return (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M14.644 19.908 20.1 5.188a1 1 0 0 0-1.285-1.285L4.09 9.363c-.921.342-.849 1.668.104 1.907l6.834 1.717 1.707 6.816c.24.954 1.567 1.027 1.909.105v0Z'
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='m19.87 4.13-8.84 8.86'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-settings-round':
      return (
        <>
          <path
            clipRule='evenodd'
            d='m9.653 18.637.526 1.183a1.992 1.992 0 0 0 3.642 0l.526-1.183c.187-.42.502-.77.9-1 .4-.232.864-.33 1.324-.282l1.287.137a1.99 1.99 0 0 0 1.82-3.153l-.761-1.048A2.187 2.187 0 0 1 18.503 12c0-.462.146-.913.418-1.287l.762-1.047a1.992 1.992 0 0 0-1.82-3.153l-1.288.137a2.183 2.183 0 0 1-2.224-1.287l-.53-1.183a1.992 1.992 0 0 0-3.642 0l-.526 1.183a2.184 2.184 0 0 1-.9 1.005c-.4.231-.864.33-1.324.282l-1.291-.137a1.99 1.99 0 0 0-1.82 3.153l.761 1.047a2.187 2.187 0 0 1 0 2.573l-.762 1.048a1.994 1.994 0 0 0 1.82 3.153l1.288-.137a2.184 2.184 0 0 1 2.228 1.287Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
          />
          <circle
            cx={12}
            cy={12}
            r={2.648}
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-draft':
      return (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M3.503 9.665v8.925c0 1.061.86 1.92 1.92 1.92h13.44c1.06 0 1.92-.859 1.92-1.92V9.665'
            fill={bgfill}
          />
          <path
            d='M3.503 9.665v8.925c0 1.061.86 1.92 1.92 1.92h13.44c1.06 0 1.92-.859 1.92-1.92V9.665M9.379 14.635l-5.31 5.31M20.217 19.944l-5.309-5.309'
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='m6.383 6.708-2.03 1.365a1.92 1.92 0 0 0 0 3.186l5.64 3.794a3.85 3.85 0 0 0 4.299 0l5.639-3.794a1.92 1.92 0 0 0 0-3.186l-2.028-1.365'
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M17.903 12.624V4.096a.96.96 0 0 0-.96-.96h-9.6a.96.96 0 0 0-.96.96v8.528'
            fill={bgfill}
          />
          <path
            d='M17.903 12.624V4.096a.96.96 0 0 0-.96-.96h-9.6a.96.96 0 0 0-.96.96v8.528M9.263 6.59h5.76M9.263 9.95h5.76'
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-essential':
      return (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M20.417 7.667h-16.5A.917.917 0 0 1 3 6.75V4.917C3 4.41 3.41 4 3.917 4h16.5c.506 0 .916.41.916.917V6.75c0 .506-.41.917-.916.917Z'
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M20.111 7.667v11c0 1.013-.82 1.833-1.833 1.833H6.055a1.833 1.833 0 0 1-1.833-1.833v-11'
            fill={bgfill}
          />
          <path
            d='M20.111 7.667v11c0 1.013-.82 1.833-1.833 1.833H6.055a1.833 1.833 0 0 1-1.833-1.833v-11M9.417 11.333h5.5'
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-delete':
      return (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M15.543 21.004H8.457a2.25 2.25 0 0 1-2.244-2.079L5.247 6.373h13.506l-.966 12.552a2.25 2.25 0 0 1-2.244 2.079Z'
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M20.003 6.373H3.997'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M9.186 2.996h5.628c.621 0 1.125.504 1.125 1.126v2.25H8.061v-2.25c0-.622.504-1.126 1.125-1.126Z'
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M13.97 10.874v5.628M10.03 10.874v5.628'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-big-left-arrow':
      return (
        <path
          d='m16 3-9 9.002L15.995 21'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-big-right-arrow':
      return (
        <path
          d='m7.505 3 8.995 9.027L7.5 21'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-right-arrow':
      return (
        <path
          d='m10 16 4-4-4-4'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-edit':
      return (
        <path
          d='M3 21h18M15.87 7.95l-2.82-2.82m4.602-.379-1.403-1.403a.999.999 0 0 0-1.414 0L4 14.182V17h2.818L17.652 6.166a1 1 0 0 0 0-1.415Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-edit-pen':
      return (
        <>
          <path
            d='m18.91 7.91-2.82-2.82M21 11v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8m7.707 1.707-1.414-1.414a.999.999 0 0 0-1.414 0L7.293 13.879a.997.997 0 0 0-.293.707V17h2.414c.265 0 .52-.105.707-.293L20.707 6.121a.999.999 0 0 0 0-1.414Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-dollar':
      return (
        <>
          <path
            d='M12 8v.808M10 10.424a1.839 1.839 0 0 1 2-1.616M12 16v-.808M14 13.576a1.839 1.839 0 0 1-2 1.616M13.95 10.071A1.95 1.95 0 0 0 12 8.808M10.05 13.929A1.95 1.95 0 0 0 12 15.192M10 10.424v0c0 .684.483 1.273 1.154 1.407l1.692.338c.671.134 1.154.723 1.154 1.407v0'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            clipRule='evenodd'
            d='M20 13.02V6.57a1.012 1.012 0 0 0-.902-.992 11.392 11.392 0 0 1-5.873-2.172 2.053 2.053 0 0 0-2.45 0 11.392 11.392 0 0 1-5.873 2.172c-.508.055-.895.48-.902.991v6.452c0 3.77 4.65 6.582 6.864 7.706a2.505 2.505 0 0 0 2.276-.002C15.355 19.6 20 16.796 20 13.021Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-checked-round':
      return (
        <>
          <path
            d='M20.93 13.44a8.995 8.995 0 1 1-1.547-6.663l-7.31 7.28-3.087-3.088'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-search':
      return (
        <path
          d='m19 19-3.29-3.29m.004-8.872a6.276 6.276 0 1 1-8.876 8.876 6.276 6.276 0 0 1 8.876-8.876Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'modal-search-icon':
      return (
        <path
          d='M14.193 5.582a5.971 5.971 0 1 1-8.444 8.444 5.971 5.971 0 0 1 8.444-8.444M14.15 14.06 20 19.99'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-fill-star':
      return (
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.981 3.499a2.25 2.25 0 0 1 4.03 0l.001.002 1.958 3.904 4.338.62a2.251 2.251 0 0 1 1.242 3.855h-.001l-3.116 2.986.74 4.241v.001a2.25 2.25 0 0 1-3.255 2.388l-.002-.001-3.92-2.026-3.92 2.025h-.001a2.25 2.25 0 0 1-3.256-2.387v-.001l.74-4.24-3.115-2.985h-.001a2.25 2.25 0 0 1 1.24-3.856l4.34-.62L9.98 3.499Z'
          fill={fill}
        />
      );
    case 'icon-close':
      return (
        <path
          d='M18 6 6 18M6 6l12 12'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-t-fomat':
      return (
        <path
          d='M8.999 9.75H15M12 9.75v5.501m-4.004 5.753h8.008a5 5 0 0 0 5-5V7.996a5 5 0 0 0-5-5H7.996a5 5 0 0 0-5 5v8.008a5 5 0 0 0 5 5Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-document':
      return (
        <path
          d='M8 13h8m-8 4h8m4-9h-4a1 1 0 0 1-1-1V3M8 9h3M6 3h9.172a2 2 0 0 1 1.414.586l2.828 2.828A2 2 0 0 1 20 7.828V19a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-timer':
      return (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M8.557 3.687a8.998 8.998 0 0 1 11.756 4.87 8.998 8.998 0 0 1-4.87 11.756A8.998 8.998 0 1 1 8.557 3.687'
            fill={bgfill}
          />
          <path
            d='M8.557 3.687a8.998 8.998 0 0 1 11.756 4.87 8.998 8.998 0 0 1-4.87 11.756A8.998 8.998 0 1 1 8.557 3.687'
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M11.718 7.985v4.651l3.656 2.23'
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-show':
      return (
        <>
          <path
            clipRule='evenodd'
            d='M14.122 9.88a3.004 3.004 0 0 1 0 4.245 3.004 3.004 0 0 1-4.245 0 3.004 3.004 0 0 1 0-4.245 3 3 0 0 1 4.245 0Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            clipRule='evenodd'
            d='M3 12c0-.659.152-1.311.446-1.912C4.961 6.991 8.309 5 12 5s7.039 1.991 8.554 5.088c.294.601.446 1.253.446 1.912s-.152 1.311-.446 1.912C19.039 17.009 15.691 19 12 19s-7.039-1.991-8.554-5.088A4.346 4.346 0 0 1 3 12Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-information':
      return (
        <>
          <path
            d='m12 12.711 1.328-.737A2.087 2.087 0 0 0 14.4 10.15a2.298 2.298 0 0 0-2.42-2.152 2.345 2.345 0 0 0-2.382 1.813'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <circle
            cx={12}
            cy={12}
            r={9.004}
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M12.1 15.902a.1.1 0 1 1-.2 0 .1.1 0 0 1 .2 0'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-repeat':
      return (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M7.38 18A1.38 1.38 0 0 1 6 16.62V6h10.62c.762 0 1.38.618 1.38 1.38V18H7.38Z'
            fill={bgfill}
          />
          <path
            d='M19 11v6a2 2 0 0 1-2 2H5M5 13V7a2 2 0 0 1 2-2h12'
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M7.5 16.5 5 19l2.5 2.5M16 8l3-3-3-3'
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-tools':
      return (
        <>
          <path
            clipRule='evenodd'
            d='m9.717 18.64.527 1.184a1.992 1.992 0 0 0 3.641 0l.526-1.184c.188-.42.503-.77.9-1 .401-.23.865-.33 1.324-.281l1.288.137a1.99 1.99 0 0 0 1.82-3.153l-.762-1.048a2.187 2.187 0 0 1-.414-1.291c0-.463.146-.913.418-1.287l.763-1.047a1.992 1.992 0 0 0-1.82-3.153l-1.289.137a2.184 2.184 0 0 1-2.224-1.287l-.53-1.184a1.992 1.992 0 0 0-3.641 0l-.527 1.184a2.184 2.184 0 0 1-.9 1.005c-.4.231-.864.33-1.323.282l-1.292-.138a1.99 1.99 0 0 0-1.82 3.153l.762 1.048a2.187 2.187 0 0 1 0 2.573l-.763 1.048a1.994 1.994 0 0 0 1.82 3.153l1.289-.137a2.184 2.184 0 0 1 2.228 1.287Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
          />
          <circle
            cx={12.065}
            cy={12.004}
            r={2.648}
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-keypad':
      return (
        <path
          clipRule='evenodd'
          d='M5 14v0a2 2 0 0 1-2-2v0a2 2 0 0 1 2-2v0a2 2 0 0 1 2 2v0a2 2 0 0 1-2 2ZM12 14v0a2 2 0 0 1-2-2v0a2 2 0 0 1 2-2v0a2 2 0 0 1 2 2v0a2 2 0 0 1-2 2ZM19 14v0a2 2 0 0 1-2-2v0a2 2 0 0 1 2-2v0a2 2 0 0 1 2 2v0a2 2 0 0 1-2 2ZM5 21v0a2 2 0 0 1-2-2v0a2 2 0 0 1 2-2v0a2 2 0 0 1 2 2v0a2 2 0 0 1-2 2ZM12 21v0a2 2 0 0 1-2-2v0a2 2 0 0 1 2-2v0a2 2 0 0 1 2 2v0a2 2 0 0 1-2 2ZM19 21v0a2 2 0 0 1-2-2v0a2 2 0 0 1 2-2v0a2 2 0 0 1 2 2v0a2 2 0 0 1-2 2ZM5 7v0a2 2 0 0 1-2-2v0a2 2 0 0 1 2-2v0a2 2 0 0 1 2 2v0a2 2 0 0 1-2 2ZM12 7v0a2 2 0 0 1-2-2v0a2 2 0 0 1 2-2v0a2 2 0 0 1 2 2v0a2 2 0 0 1-2 2ZM19 7v0a2 2 0 0 1-2-2v0a2 2 0 0 1 2-2v0a2 2 0 0 1 2 2v0a2 2 0 0 1-2 2Z'
          stroke={fill}
          fill='none'
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-maximius':
      return (
        <path
          clipRule='evenodd'
          d='M18.417 20.25H5.583a1.833 1.833 0 0 1-1.833-1.833V5.583c0-1.013.821-1.833 1.833-1.833h12.833c1.013 0 1.833.821 1.833 1.833v12.833a1.832 1.832 0 0 1-1.832 1.834Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-minus':
      return (
        <path
          d='M20 12H4'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-message':
      return (
        <path
          d='M15.5 14.5h-7m0-4h7M4.151 16.396A8.95 8.95 0 0 1 3 12a9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9 8.95 8.95 0 0 1-4.396-1.151L3 21l1.151-4.604Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-resource':
      return (
        <path
          d='m6.17 12.63 3 1.74M3.342 7.001 12 12m0 0 8.658-4.999M12 12v10m4.33-12.5L7.54 4.27m13.386 11.729V8.001c0-.715-.381-1.375-1-1.732L13 2.27a2.001 2.001 0 0 0-2 0L4.074 6.269a2 2 0 0 0-1 1.732v7.997c0 .715.381 1.375 1 1.732l6.926 4a2.001 2.001 0 0 0 2 0l6.926-3.999a2 2 0 0 0 1-1.732Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-feedback':
      return (
        <>
          <path
            clipRule='evenodd'
            d='M19 17h-1a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h1a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2ZM6 17H5a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h1a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M18.5 10v-.5A6.5 6.5 0 0 0 12 3v0a6.5 6.5 0 0 0-6.5 6.5v.5'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            clipRule='evenodd'
            d='M12.625 21.25h-1.25c-.69 0-1.25-.56-1.25-1.25v0c0-.69.56-1.25 1.25-1.25h1.25c.69 0 1.25.56 1.25 1.25v0c0 .69-.56 1.25-1.25 1.25Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M13.875 20H16a2 2 0 0 0 2-2v-1'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-send-email':
      return (
        <>
          <path
            clipRule='evenodd'
            d='m10.48 18.71 10.988-5.832a.998.998 0 0 0 0-1.765L10.497 5.29c-.828-.44-1.756.39-1.405 1.256l2.189 5.4-2.207 5.51c-.346.867.58 1.692 1.407 1.254Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M11.28 11.95 22 12M4 15h1.6M3 12h2.6M2 9h3.6'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-follow-up':
      return (
        <path
          d='M14.053 12.301h1.949v-1.95m-8.004 1.95a4.412 4.412 0 0 1 7.75 0m-8.25 3.7h1m3.002 0h1m3.001 0h1M7.499 2.997v3.001m9.004-3v3M5.996 21.005h12.008a3 3 0 0 0 3-3V7.497a3 3 0 0 0-3-3H5.996a3 3 0 0 0-3 3v10.507a3 3 0 0 0 3 3Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-video':
      return (
        <path
          d='m16 10.293 3.475-2.143A1 1 0 0 1 21 9.002v6.996a1 1 0 0 1-1.525.852L16 14.707M6 19h7a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-reply':
      return (
        <path
          clipRule='evenodd'
          d='M11 13.097v3.068c0 .867-1.029 1.323-1.672.741l-6.03-5.466a.999.999 0 0 1 .025-1.503l6.03-5.118A1 1 0 0 1 11 5.581v2.437c5.463 0 10 3.372 10 8.982v1.129c-1.847-3.684-5.687-5.032-10-5.032Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-forward':
      return (
        <path
          clipRule='evenodd'
          d='M13 13.097v3.068c0 .867 1.029 1.323 1.672.741l6.03-5.466a.999.999 0 0 0-.025-1.503l-6.03-5.118A1 1 0 0 0 13 5.581v2.437C7.537 8.018 3 11.39 3 17v1.129c1.847-3.684 5.687-5.032 10-5.032Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-done':
      return (
        <>
          <path
            clipRule='evenodd'
            d='M12 21v0a9 9 0 0 1-9-9v0a9 9 0 0 1 9-9v0a9 9 0 0 1 9 9v0a9 9 0 0 1-9 9Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='m16 10-5 5-3-3'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-assign':
      return (
        <path
          d='M21 12V8a5 5 0 0 0-5-5H8a5 5 0 0 0-5 5v8a5 5 0 0 0 5 5h5m7-4-2-2m0 0-2 2m2-2v5m-5-5.5H9.789c-.993 0-1.892.59-2.289 1.5m7-6.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-down-arrow':
      return (
        <path
          d='m8 10 4 4 4-4'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-up-arrow':
      return (
        <path
          d='m16 14-4-4-4 4'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-tag':
      return (
        <>
          <path
            clipRule='evenodd'
            d='m6.49 6.538-3.071 4.3a2 2 0 0 0 0 2.325l3.071 4.3a2 2 0 0 0 1.627.837H19a2 2 0 0 0 2-2V7.7a2 2 0 0 0-2-2H8.117c-.646 0-1.252.312-1.627.838Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            clipRule='evenodd'
            d='M10.573 10.727a1.8 1.8 0 1 1-2.546 2.546 1.8 1.8 0 0 1 2.546-2.546Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-pluse':
      return (
        <path
          d='M12 4v16m8-8H4'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-recording':
      return (
        <>
          <path
            d='M15.752 10H8.248'
            stroke={fill}
            fill='none'
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            clipRule='evenodd'
            d='M7.998 2.996h8.004a5.002 5.002 0 0 1 5.002 5.002v8.004a5.002 5.002 0 0 1-5.002 5.002H7.998a5.002 5.002 0 0 1-5.002-5.002V7.998a5.002 5.002 0 0 1 5.002-5.002Z'
            stroke={fill}
            fill='none'
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <circle
            cx={8.248}
            cy={12.25}
            r={2.251}
            stroke={fill}
            fill='none'
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <circle
            cx={15.752}
            cy={12.25}
            r={2.251}
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-microphone-on':
      return (
        <>
          <path
            clipRule='evenodd'
            d='M12 16v0a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4v0a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M19 11v.9c0 3.921-3.134 7.1-7 7.1v0c-3.866 0-7-3.179-7-7.1V11M11.5 6h1M11 9h2M11.5 12.03h1M12 19v3M9 22h6'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-microphone-off':
      return (
        <>
          <path
            d='M12 19v3M9 22h6M8.36 4.36A3.994 3.994 0 0 1 16 6v6M4.25 4.25l15.5 15.5M8 8v4a4 4 0 0 0 6.828 2.828M19.1 11v.9c0 .947-.189 1.848-.525 2.674'
            stroke={fill}
            strokeWidth={strokeWidth}
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M4.9 11v.9A7.1 7.1 0 0 0 12 19a7.073 7.073 0 0 0 4.968-2.032'
            stroke={fill}
            strokeWidth={strokeWidth}
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-printer':
      return (
        <path
          d='M7 8V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v4M7 17H5a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2M7 11h1m-1 2.8h10V20a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-6.2Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-details':
      return (
        <>
          <circle
            cx={7.498}
            cy={7.498}
            r={4.502}
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M15.001 10h6.003M15.001 4.997h6.003M21.004 15.001H8.999M21.004 20.003H8.999M7.498 7.816v1.5M4.746 14.751a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5M4.746 19.753a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5M7.498 5.711a.05.05 0 1 0 0 .1.05.05 0 0 0 0-.1'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-today':
      return (
        <path
          d='M7.498 2.996v3.001m9.004-3v3M2.996 9.5h18.008M5.996 21.004h12.008a3 3 0 0 0 3-3V7.497a3 3 0 0 0-3-3H5.996a3 3 0 0 0-3 3v10.507a3 3 0 0 0 3 3Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-tomorrow':
      return (
        <path
          d='M12 4V2m0 20v-2m6.36-14.36.71-.71M4.93 19.07l.71-.71M20 12h2M2 12h2m14.36 6.36.71.71M4.93 4.93l.71.71m9.896 2.824a5 5 0 1 1-7.072 7.072 5 5 0 0 1 7.072-7.072Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-next-week':
      return (
        <path
          d='M16.502 2.996v3.001m-9.004-3v3M13.01 11l2.001 2-2 2.001m-4.012-2H15m-9.005 8.003h12.008a3 3 0 0 0 3-3V7.497a3 3 0 0 0-3-3H5.996a3 3 0 0 0-3 3v10.507a3 3 0 0 0 3 3Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-next':
      return (
        <path
          d='M18 6.75v10.5m-5.075-6.129L6.586 7.159A1.037 1.037 0 0 0 5 8.038v7.923c0 .814.896 1.311 1.586.879l6.338-3.962a1.035 1.035 0 0 0 .001-1.757Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-stop':
      return (
        <path
          d='m9 15 6-6m0 6L9 9M7.414 20.414l-3.828-3.828A2 2 0 0 1 3 15.172V8.828a2 2 0 0 1 .586-1.414l3.828-3.828A2 2 0 0 1 8.828 3h6.343a2 2 0 0 1 1.414.586l3.828 3.828c.376.375.587.884.587 1.414v6.343a2 2 0 0 1-.586 1.414L16 21H8.828a2 2 0 0 1-1.414-.586Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-arrow-right':
      return (
        <path
          d='M5 12h14m0 0-6 6m6-6-6-6'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-call':
      return (
        <path
          d='M13 7.027a3.944 3.944 0 0 1 4.009 4.009M12.999 3c2.056 0 4.114.785 5.682 2.354a8.012 8.012 0 0 1 2.354 5.682m-2.07 5.61-1.174-1.173a1.5 1.5 0 0 0-2.12 0l-.922.922a.71.71 0 0 1-.785.158c-1.335-.585-2.655-1.472-3.832-2.649a12.646 12.646 0 0 1-2.642-3.817.733.733 0 0 1 .162-.811l.826-.826c.67-.671.67-1.62.085-2.206L7.39 5.071a2 2 0 0 0-2.828 0l-.652.651c-.741.741-1.05 1.81-.85 2.87.494 2.613 2.012 5.474 4.46 7.923 2.45 2.449 5.31 3.967 7.924 4.461 1.06.2 2.129-.109 2.87-.85l.65-.651a2 2 0 0 0 0-2.829Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-outgoing':
      return (
        <path
          d='M21 9V3m0 0h-6m6 0-6 6m-4.869 4.869a12.634 12.634 0 0 1-2.638-3.809.75.75 0 0 1 .166-.827l.819-.819c.671-.671.671-1.62.085-2.206L7.39 5.035a2 2 0 0 0-2.828 0l-.652.651c-.741.741-1.05 1.81-.85 2.87.494 2.613 2.012 5.474 4.461 7.923 2.449 2.449 5.31 3.967 7.923 4.461 1.06.2 2.129-.109 2.87-.85l.651-.651a2 2 0 0 0 0-2.828l-1.173-1.173a1.5 1.5 0 0 0-2.121 0l-.903.904a.749.749 0 0 1-.827.166 12.678 12.678 0 0 1-3.81-2.639Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-ingoing':
      return (
        <path
          d='M15 3v6m0 0h6m-6 0 6-6M10.131 13.869a12.634 12.634 0 0 1-2.638-3.809.75.75 0 0 1 .166-.827l.819-.819c.671-.671.671-1.62.085-2.206L7.39 5.035a2 2 0 0 0-2.828 0l-.652.651c-.741.741-1.05 1.81-.85 2.87.494 2.613 2.012 5.474 4.461 7.923 2.449 2.449 5.31 3.967 7.923 4.461 1.06.2 2.129-.109 2.87-.85l.651-.651a2 2 0 0 0 0-2.828l-1.173-1.173a1.5 1.5 0 0 0-2.121 0l-.903.904a.749.749 0 0 1-.827.166 12.678 12.678 0 0 1-3.81-2.639Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-download':
      return (
        <path
          d='M12 17V3m9 14a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4m14-5-5.001 5.001-5-5.001'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-user-card':
      return (
        <path
          d='M18 15.434a2.383 2.383 0 0 0-2.208-1.5h-4.584A2.374 2.374 0 0 0 9 15.434M18 18v1.333c0 .921-.746 1.667-1.667 1.667H4.667A1.667 1.667 0 0 1 3 19.333V7.667C3 6.746 3.746 6 4.667 6H6m13.333 12H7.667A1.667 1.667 0 0 1 6 16.333V4.667C6 3.746 6.746 3 7.667 3h11.667C20.254 3 21 3.746 21 4.667v11.667c0 .92-.746 1.666-1.667 1.666ZM15.268 7.166a2.501 2.501 0 1 1-3.538 3.536 2.501 2.501 0 0 1 3.538-3.536Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-lead':
      return (
        <path
          d='M16.502 18.003a2.384 2.384 0 0 0-2.21-1.501H9.708a2.375 2.375 0 0 0-2.209 1.5M4.78 5.998v-1a2 2 0 0 1 2-2h10.44a2 2 0 0 1 2.001 2v1m-.263 15.007H5.043a2 2 0 0 1-2-2.001V7.998a2 2 0 0 1 2-2h13.914a2 2 0 0 1 2 2v11.005a2 2 0 0 1-2 2ZM12 8.999A2.5 2.5 0 1 1 12 14 2.5 2.5 0 0 1 12 9Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-refresh':
      return (
        <path
          d='M4.034 7.439a8.502 8.502 0 0 1 15.97 4.065M3 13.504a8.502 8.502 0 0 0 15.97 4.065M7.046 8.179H3.509V4.64m12.446 12.19h3.536v3.538'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-email-open':
      return (
        <path
          d='M3 9.703V19a2 2 0 0 0 2 2h13.999a2 2 0 0 0 2-2V9.703M9.12 14.88l-5.53 5.53m16.82 0-5.53-5.53M3.886 8.044l6.994-4.705a2.007 2.007 0 0 1 2.239 0l6.994 4.705a2 2 0 0 1 0 3.319l-5.874 3.952a4.01 4.01 0 0 1-4.478 0l-5.874-3.952a2 2 0 0 1-.001-3.319Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-two-way':
      return (
        <path
          d='M16.103 10.793 19 7.897 16.103 5M5 7.9h14M7.897 13.207 5 16.103 7.897 19M19 16.1H5'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-cash-protection':
      return (
        <path
          d='M12 8v.808m0 0a1.839 1.839 0 0 0-2 1.616c0 .684.483 1.273 1.154 1.407l1.692.338c.671.134 1.154.723 1.154 1.407a1.839 1.839 0 0 1-2 1.616m0-6.384a1.95 1.95 0 0 1 1.95 1.263M12 16v-.808m0 0a1.95 1.95 0 0 1-1.95-1.263M20 13.02V6.569a1.012 1.012 0 0 0-.902-.991 11.392 11.392 0 0 1-5.873-2.172 2.053 2.053 0 0 0-2.45 0 11.392 11.392 0 0 1-5.873 2.172c-.508.055-.895.48-.902.991v6.452c0 3.77 4.65 6.582 6.864 7.706a2.505 2.505 0 0 0 2.276-.002C15.355 19.6 20 16.796 20 13.021Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-buy-number':
      return (
        <path
          d='M10.5 21h-5a2 2 0 0 1-2-2m0 0a2 2 0 0 1 2-2h4m-6 2V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v5m-1.667 7h-2.666m1.333-1.333v2.666m4-1.333a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-add-number':
      return (
        <path
          d='m20.003 12-4.001 2m4.001 2.002-4.001 2m0 3.002v-9.768a2 2 0 0 1 1.106-1.79l2.895-1.448m-17.007-1h3.001m-3 4.002h3m-3 4.001h3m0 6.003h12.006a2 2 0 0 0 2-2V4.996a2 2 0 0 0-2-2H5.997a2 2 0 0 0-2 2v14.008a2 2 0 0 0 2 2Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-porting':
      return (
        <path
          d='M14 3.23c3.369.77 6 3.401 6.77 6.77M10 3.23A8.997 8.997 0 1 0 20.77 14m-8.775-5.995a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-notification':
      return (
        <>
          <path
            clipRule='evenodd'
            fill='none'
            d='M16.898 16.532a1.9 1.9 0 0 0 1.9-1.895v0c0-.533-.213-1.044-.591-1.42l-1.26-1.26V8.212a5.546 5.546 0 0 0-5.552-5.545v0a5.546 5.546 0 0 0-5.543 5.545v3.742l-1.26 1.26A2.007 2.007 0 0 0 4 14.634v0a1.9 1.9 0 0 0 1.9 1.895l10.998.003Z'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M9.916 19.674h2.958'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-thumbs-up':
      return (
        <>
          <path
            d='m8 10.572 3.649-4.751a1.734 1.734 0 0 1 2.714-.046c.265.321.409.725.409 1.141v3.271h3.096a1.8 1.8 0 0 1 1.496.799l.329.491a1.8 1.8 0 0 1 .234 1.499l-1.359 4.722A1.8 1.8 0 0 1 16.839 19H10.55a1.8 1.8 0 0 1-1.318-.574L8 17.1M6.944 19H5.056A1.056 1.056 0 0 1 4 17.944v-7.388C4 9.973 4.473 9.5 5.056 9.5h1.888C7.527 9.5 8 9.973 8 10.556v7.388C8 18.527 7.527 19 6.944 19Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-smiley':
      return (
        <>
          <path
            d='M21.004 12A9.004 9.004 0 1 1 12 2.996'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            clipRule='evenodd'
            fill='none'
            d='M18.343 2.388a.752.752 0 0 1 1.32 0l.584 1.065c.069.127.173.231.3.3l1.065.583a.752.752 0 0 1 0 1.321l-1.065.584a.745.745 0 0 0-.3.3l-.584 1.064a.752.752 0 0 1-1.32 0l-.584-1.065a.743.743 0 0 0-.3-.3l-1.065-.583a.752.752 0 0 1 0-1.321l1.065-.582a.753.753 0 0 0 .3-.3l.584-1.066Z'
            stroke={fill}
            strokeWidth={strokeWidth}
          />
          <path
            d='M8.999 9.329v1M15.001 9.329v1M15.243 14.66a4.588 4.588 0 0 1-6.485 0'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-import':
      return (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M2.25 15a.75.75 0 0 1 .75-.75h4.382c.663 0 1.269.374 1.565.968l.446.893c.044.086.13.139.225.139h4.764c.095 0 .18-.053.223-.138l.447-.894a1.752 1.752 0 0 1 1.566-.968H21a.75.75 0 0 1 0 1.5h-4.382a.251.251 0 0 0-.224.139l-.447.893a1.749 1.749 0 0 1-1.565.968H9.618a1.751 1.751 0 0 1-1.565-.967l-.448-.895a.25.25 0 0 0-.223-.138H3a.75.75 0 0 1-.75-.75Z'
            fill={fill}
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M5 3.75c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V5c0-.69-.56-1.25-1.25-1.25h-2a.75.75 0 0 1 0-1.5h2A2.75 2.75 0 0 1 21.75 5v14A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19V5A2.75 2.75 0 0 1 5 2.25h2a.75.75 0 0 1 0 1.5H5Z'
            fill={fill}
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12.01 2.25a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75Z'
            fill={fill}
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M7.879 7.879a.75.75 0 0 1 1.06 0L12 10.939l3.06-3.06a.75.75 0 1 1 1.061 1.06l-3.59 3.591a.75.75 0 0 1-1.061 0L7.879 8.94a.75.75 0 0 1 0-1.061Z'
            fill={fill}
          />
        </>
      );
    case 'icon-export':
      return (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M5 3.75c-.69 0-1.25.56-1.25 1.25v9.25h3.632c.663 0 1.269.374 1.565.968m0 0 .446.893c.044.086.13.139.225.139h4.764c.095 0 .18-.053.223-.138l.447-.894a1.752 1.752 0 0 1 1.566-.968h3.632V5c0-.69-.56-1.25-1.25-1.25h-2a.75.75 0 0 1 0-1.5h2A2.75 2.75 0 0 1 21.75 5v14A2.75 2.75 0 0 1 19 21.75H5A2.75 2.75 0 0 1 2.25 19V5A2.75 2.75 0 0 1 5 2.25h2a.75.75 0 0 1 0 1.5H5m15.25 12h-3.632a.251.251 0 0 0-.224.139l-.447.893a1.749 1.749 0 0 1-1.565.968H9.618a1.751 1.751 0 0 1-1.565-.967l-.448-.895a.25.25 0 0 0-.223-.138H3.75V19c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25v-3.25ZM11.24 4.82V12a.75.75 0 0 0 1.5 0V4.8l2.32 2.321a.75.75 0 0 0 1.061-1.06l-3.59-3.591A.75.75 0 0 0 12 2.25h-.01a.749.749 0 0 0-.598.297L7.879 6.061a.75.75 0 1 0 1.06 1.06l2.301-2.3Z'
            fill={fill}
          />
        </>
      );
    case 'icon-column-chooser':
      return (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M4.477 2.298a2.837 2.837 0 0 0-1.921 1.464c-.327.651-.31.18-.296 8.402l.013 7.406.121.31c.067.171.18.414.254.54.207.356.71.823 1.095 1.015.674.337.176.32 8.421.305l7.406-.013.316-.123c.869-.338 1.437-.92 1.735-1.776l.106-.305V12c0-7.23-.004-7.534-.088-7.781a2.812 2.812 0 0 0-.71-1.149 2.58 2.58 0 0 0-1.27-.727c-.353-.09-.536-.093-7.678-.088-4.024.003-7.401.022-7.504.043ZM8.25 12v8.25H6.524c-1.992 0-2.035-.007-2.406-.377-.397-.397-.368.219-.368-7.897 0-8.115-.032-7.448.378-7.858.353-.353.404-.361 2.4-.365L8.25 3.75V12Zm6 0v8.25h-4.5V3.75h4.5V12Zm5.181-8.172c.144.05.31.16.446.295.404.404.373-.257.373 7.877s.031 7.473-.373 7.877c-.365.366-.413.373-2.401.373H15.75V3.75h1.726c1.488 0 1.758.01 1.955.078Z'
            fill={fill}
          />
        </>
      );
    case 'icon-cellphone':
      return (
        <path
          d='M10.75 6h2.5M16 21H8a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2Zm-4.001-3.75a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-warning':
      return (
        <path
          d='M12 13.12V9.38m-.001 6.745a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5Zm2.03-11.986 7.659 13.404c.89 1.558-.235 3.497-2.029 3.497H4.341c-1.795 0-2.92-1.939-2.029-3.497L9.971 4.139c.897-1.571 3.161-1.571 4.058 0Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-column-edit':
      return (
        <path
          d='M21 11V6a3 3 0 0 0-3-3H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h5m4-18v9M9 3v18m-6-6.06h9m-9-6h18m-2.707 11.767 3.414-3.414a1 1 0 0 0 0-1.414l-1.586-1.586a1 1 0 0 0-1.414 0l-3.414 3.414a1 1 0 0 0-.293.707V20.5a.5.5 0 0 0 .5.5h2.086a1 1 0 0 0 .707-.293Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-drag-and-drop':
      return (
        <path
          d='M16 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM16 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM16 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM8 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM8 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM8 22a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z'
          fill={fill}
          strokeWidth={strokeWidth}
        />
      );
    case 'icon-contact':
      return (
        <path
          d='M20 20v-.75A4.25 4.25 0 0 0 15.75 15h-7.5A4.25 4.25 0 0 0 4 19.25V20M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-t-square':
      return (
        <path
          d='M5.5 10h3M7 4v6m3-4.642V4.333A.333.333 0 0 0 9.667 4H4.333A.333.333 0 0 0 4 4.333v1.025M4 14v4a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-5M8 16h9m-5-4h5m-4-4h4'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-keyboard':
      return (
        <path
          d='M8.335 17.33a.75.75 0 1 0-.67 1.34l.67-1.34ZM12 20l-.335.67a.75.75 0 0 0 .67 0L12 20Zm4.335-1.33a.75.75 0 1 0-.67-1.34l.67 1.34ZM6 6.25H5v1.5h1v-1.5Zm-1 0A.25.25 0 0 1 4.75 6h-1.5c0 .966.784 1.75 1.75 1.75v-1.5ZM4.75 6V5h-1.5v1h1.5Zm0-1A.25.25 0 0 1 5 4.75v-1.5A1.75 1.75 0 0 0 3.25 5h1.5ZM5 4.75h1v-1.5H5v1.5Zm1 0a.25.25 0 0 1 .25.25h1.5A1.75 1.75 0 0 0 6 3.25v1.5Zm.25.25v1h1.5V5h-1.5Zm0 1a.25.25 0 0 1-.25.25v1.5A1.75 1.75 0 0 0 7.75 6h-1.5Zm6.25.25h-1v1.5h1v-1.5Zm-1 0a.25.25 0 0 1-.25-.25h-1.5c0 .966.784 1.75 1.75 1.75v-1.5ZM11.25 6V5h-1.5v1h1.5Zm0-1a.25.25 0 0 1 .25-.25v-1.5A1.75 1.75 0 0 0 9.75 5h1.5Zm.25-.25h1v-1.5h-1v1.5Zm1 0a.25.25 0 0 1 .25.25h1.5a1.75 1.75 0 0 0-1.75-1.75v1.5Zm.25.25v1h1.5V5h-1.5Zm0 1a.25.25 0 0 1-.25.25v1.5A1.75 1.75 0 0 0 14.25 6h-1.5Zm6.25.25h-1v1.5h1v-1.5Zm-1 0a.25.25 0 0 1-.25-.25h-1.5c0 .966.784 1.75 1.75 1.75v-1.5ZM17.75 6V5h-1.5v1h1.5Zm0-1a.25.25 0 0 1 .25-.25v-1.5A1.75 1.75 0 0 0 16.25 5h1.5Zm.25-.25h1v-1.5h-1v1.5Zm1 0a.25.25 0 0 1 .25.25h1.5A1.75 1.75 0 0 0 19 3.25v1.5Zm.25.25v1h1.5V5h-1.5Zm0 1a.25.25 0 0 1-.25.25v1.5A1.75 1.75 0 0 0 20.75 6h-1.5ZM7.665 18.67l4 2 .67-1.34-4-2-.67 1.34Zm4.67 2 4-2-.67-1.34-4 2 .67 1.34ZM6 12.75H5v1.5h1v-1.5Zm-1 0a.25.25 0 0 1-.25-.25h-1.5c0 .966.784 1.75 1.75 1.75v-1.5Zm-.25-.25v-1h-1.5v1h1.5Zm0-1a.25.25 0 0 1 .25-.25v-1.5a1.75 1.75 0 0 0-1.75 1.75h1.5Zm.25-.25h1v-1.5H5v1.5Zm1 0a.25.25 0 0 1 .25.25h1.5A1.75 1.75 0 0 0 6 9.75v1.5Zm.25.25v1h1.5v-1h-1.5Zm0 1a.25.25 0 0 1-.25.25v1.5a1.75 1.75 0 0 0 1.75-1.75h-1.5Zm6.25.25h-1v1.5h1v-1.5Zm-1 0a.25.25 0 0 1-.25-.25h-1.5c0 .966.784 1.75 1.75 1.75v-1.5Zm-.25-.25v-1h-1.5v1h1.5Zm0-1a.25.25 0 0 1 .25-.25v-1.5a1.75 1.75 0 0 0-1.75 1.75h1.5Zm.25-.25h1v-1.5h-1v1.5Zm1 0a.25.25 0 0 1 .25.25h1.5a1.75 1.75 0 0 0-1.75-1.75v1.5Zm.25.25v1h1.5v-1h-1.5Zm0 1a.25.25 0 0 1-.25.25v1.5a1.75 1.75 0 0 0 1.75-1.75h-1.5Zm6.25.25h-1v1.5h1v-1.5Zm-1 0a.25.25 0 0 1-.25-.25h-1.5c0 .966.784 1.75 1.75 1.75v-1.5Zm-.25-.25v-1h-1.5v1h1.5Zm0-1a.25.25 0 0 1 .25-.25v-1.5a1.75 1.75 0 0 0-1.75 1.75h1.5Zm.25-.25h1v-1.5h-1v1.5Zm1 0a.25.25 0 0 1 .25.25h1.5A1.75 1.75 0 0 0 19 9.75v1.5Zm.25.25v1h1.5v-1h-1.5Zm0 1a.25.25 0 0 1-.25.25v1.5a1.75 1.75 0 0 0 1.75-1.75h-1.5Z'
          fill={fill}
          strokeWidth={strokeWidth}
        />
      );
    case 'icon-check-square':
      return (
        <path
          d='m8.712 12.566 2.193 2.193 4.787-4.788M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-calendar':
      return (
        <>
          <path
            d='M16 2v4M8 2v4M3 9h18m-2-5H5a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M7.013 12.729a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5M12.013 12.729a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5M17.013 12.729a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5M7.013 16.729a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5M12.013 16.729a.25.25 0 1 0 .002.5.25.25 0 0 0-.002-.5'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-drop-down-menu':
      return (
        <path
          d='M3.5 17h17m-17 4h17m-4-13.75L15 8.75l-1.5-1.5M5 13h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-email-symbol':
      return (
        <path
          d='M17.002 21.004H12A9.004 9.004 0 1 1 21.004 12v1.5a2.501 2.501 0 1 1-5.002 0V12A4.002 4.002 0 0 0 12 7.998v0A4.002 4.002 0 1 0 16.002 12'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-earth':
      return (
        <path
          d='M21 12c0-4.982-4.018-9-9-9s-9 4.018-9 9m18 0c0 4.982-4.018 9-9 9s-9-4.018-9-9m18 0H3m7.168-7.94c-2.89 4.825-2.89 11.056 0 15.881a2.114 2.114 0 0 0 3.665 0c2.89-4.825 2.89-11.056 0-15.881a2.114 2.114 0 0 0-3.665 0Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-summary':
      return (
        <path
          d='M7.998 13h-.94m9.944 0H11m-4.002 4.002h1m3.001 0h6.003M2.996 8.522h18.008M5.996 21.005h12.008a3 3 0 0 0 3-3V5.996a3 3 0 0 0-3-3H5.996a3 3 0 0 0-3 3v12.008a3 3 0 0 0 3 3Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-input-field':
      return (
        <path
          d='M16 20V4m-3 13H5a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h8m3 10h3a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3m-2.5 13h5m-5-16h5M7 12h1m3 0h1'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-menu':
      return (
        <path
          d='M5.498 12h13.005M5.498 16.002h13.005M5.497 7.998h13.005'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-close-round':
      return (
        <path
          d='m14.83 9.17-5.66 5.66m5.66 0L9.17 9.17M12 21a9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9 9 9 0 0 1-9 9Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-edit-summray':
      return (
        <path
          d='M2.996 3.997h13.006M2.996 7.998H12M2.996 12h5.002m0 9.004 3.152-.39a1 1 0 0 0 .585-.285l8.634-8.63a2.166 2.166 0 0 0-3.062-3.061L8.744 17.2a1 1 0 0 0-.284.566l-.462 3.237Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-missed-call':
      return (
        <path
          d='m21 3-6 6m6 0-6-6m-4.869 10.869a12.634 12.634 0 0 1-2.638-3.809.75.75 0 0 1 .166-.827l.819-.819c.671-.671.671-1.62.085-2.206L7.39 5.035a2 2 0 0 0-2.828 0l-.652.651c-.741.741-1.05 1.81-.85 2.87.494 2.613 2.012 5.474 4.461 7.923 2.449 2.449 5.31 3.967 7.923 4.461 1.06.2 2.129-.109 2.87-.85l.651-.651a2 2 0 0 0 0-2.828l-1.173-1.173a1.5 1.5 0 0 0-2.121 0l-.903.904a.749.749 0 0 1-.827.166 12.678 12.678 0 0 1-3.81-2.639Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-call-no-answer':
      return (
        <path
          d='M19 4.72 4 19.73m6.361-2.366c1.979 1.511 4.102 2.477 6.083 2.852 1.06.2 2.129-.109 2.87-.85l.651-.651a2 2 0 0 0 0-2.829l-1.173-1.173a1.5 1.5 0 0 0-2.121 0l-.903.904a.749.749 0 0 1-.827.166 12.14 12.14 0 0 1-1.923-1.074m-2.15-1.853c-1.034-1.096-1.836-2.299-2.375-3.521a.75.75 0 0 1 .166-.826l.819-.819c.671-.671.671-1.62.085-2.206L8.39 4.31a2 2 0 0 0-2.828 0l-.652.652c-.741.741-1.05 1.81-.85 2.87.475 2.514 1.907 5.253 4.195 7.639'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-audio-play':
      return (
        <>
          <path
            clipRule='evenodd'
            d='M21 12a9 9 0 0 1-9 9 9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9Z'
            fill={'none'}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            clipRule='evenodd'
            d='m10.941 9.058 3.882 2.296a.75.75 0 0 1 0 1.291l-3.882 2.296a.75.75 0 0 1-1.132-.646V9.704a.75.75 0 0 1 1.132-.646Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-Msg-Send':
      return (
        <>
          <path
            d='M19.68 5.797v6.71M20.64 18.267h-5.76M18.72 16.347l1.92 1.92-1.92 1.92M11.04 16.347H5.28a1.92 1.92 0 0 1-1.92-1.92v-8.63'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            clipRule='evenodd'
            d='M5.29 3.867h12.46a1.93 1.93 0 0 1 1.93 1.93v0a1.93 1.93 0 0 1-.847 1.598l-5.142 3.486a3.87 3.87 0 0 1-4.342 0L4.208 7.396a1.93 1.93 0 0 1-.848-1.598v0a1.93 1.93 0 0 1 1.93-1.931Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-Msg-Receive':
      return (
        <>
          <path
            d='M19.68 5.797v6.71M20.76 18.267H15M16.92 16.347 15 18.267l1.92 1.92M11.04 16.347H5.28a1.92 1.92 0 0 1-1.92-1.92v-8.63'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            clipRule='evenodd'
            d='M5.29 3.867h12.46a1.93 1.93 0 0 1 1.93 1.93v0a1.93 1.93 0 0 1-.847 1.598l-5.142 3.486a3.87 3.87 0 0 1-4.342 0L4.208 7.396a1.93 1.93 0 0 1-.848-1.598v0a1.93 1.93 0 0 1 1.93-1.931Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-filter-sort':
      return (
        <path
          clipRule='evenodd'
          d='m14.5 13.5 5.207-5.207A1 1 0 0 0 20 7.586V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v2.586c0 .265.105.52.293.707L9.5 13.5M9.5 13.5v6.249c0 .813.764 1.41 1.553 1.213l2.5-.625a1.25 1.25 0 0 0 .947-1.213V13.5'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-filter-edit':
      return (
        <>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M17.002 21.004H6.998a4.002 4.002 0 0 1-4.002-4.002V6.998a4.002 4.002 0 0 1 4.002-4.002h10.004a4.002 4.002 0 0 1 4.002 4.002v10.004a4.002 4.002 0 0 1-4.002 4.002Z'
            fill={bgfill}
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M10.198 13.083v3.418a1 1 0 0 0 1.448.894l1.602-.801a1 1 0 0 0 .554-.895v-2.616l2.31-1.782c.246-.19.39-.482.39-.793v-1.51a1 1 0 0 0-1-1H8.497a1 1 0 0 0-1 1v1.51c0 .31.144.603.39.793l2.31 1.782Z'
            fill='#fff'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-dots-vertical':
      return (
        <path
          d='M11.997 17.502c-.275 0-.5.225-.497.5 0 .276.225.5.5.5s.5-.224.5-.5c0-.275-.225-.5-.503-.5M11.997 11.5c-.275 0-.5.225-.497.5 0 .275.225.5.5.5s.5-.225.5-.5-.225-.5-.503-.5M11.997 5.497c-.275 0-.5.225-.497.5 0 .276.225.5.5.5s.5-.224.5-.5c0-.275-.225-.5-.503-.5'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-wallet':
      return (
        <path
          d='M20 15.5h-2a2 2 0 1 1 0-4h2m0 4a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1m0 4v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5m17 6.5v-3a2 2 0 0 0-2-2H4.5A1.5 1.5 0 0 1 3 5m0 0a1.5 1.5 0 0 1 1.5-1.5H17'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-audio-pause':
      return (
        <path
          d='M14 15V9m-4 6V9m11 3a9 9 0 0 1-9 9 9 9 0 0 1-9-9 9 9 0 0 1 9-9 9 9 0 0 1 9 9Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-audio-non-disable':
      return (
        <path
          d='M15.037 16.042C16.199 15.32 17 13.818 17 12.069c0-1.749-.801-3.252-1.963-3.983m2.968 11.043C19.813 17.574 21 14.994 21 12.067 21 9.136 19.811 6.554 18 5M5.375 8.689H3a1 1 0 0 0-1 1v4.75a1 1 0 0 0 1 1h2.375l3.979 3.371A1 1 0 0 0 11 18.047V6.081c0-.852-.997-1.314-1.646-.763L5.375 8.689Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-left-arrow':
      return (
        <path
          d='m14 8-4 4 4 4'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-left':
      return (
        <path
          d='M19 12H5M11 18l-6-6M11 6l-6 6'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-link':
      return (
        <path
          d='M7.331 16.669 12 12M16.669 7.331 12 12M10.908 13.092a3.732 3.732 0 0 0-5.277 0L4.09 14.635a3.732 3.732 0 0 0 0 5.276v0a3.732 3.732 0 0 0 5.276 0l1.543-1.542a3.722 3.722 0 0 0 1.028-3.302M15.065 11.936a3.722 3.722 0 0 0 3.302-1.028l1.542-1.543a3.73 3.73 0 1 0-5.276-5.276l-1.54 1.542a3.732 3.732 0 0 0 0 5.277v0'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-toggle':
      return (
        <path
          d='M7.5 7.5a4.5 4.5 0 0 1 0 9m0-9a4.5 4.5 0 0 0 0 9m0-9h9a4.5 4.5 0 0 1 0 9h-9'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-add-notes':
      return (
        <path
          d='M8.12 10h6m-6 4h2m-2 7h-3a2 2 0 0 1-2-1.999V5a2 2 0 0 1 1.999-2H17.12a2 2 0 0 1 2 1.999V9m-17-1h2.33m-2.33 4h2.33M2 16h2.45m13.556-3.466L12.05 18.49a2.5 2.5 0 0 0-.707 1.414l-.218 1.525a.5.5 0 0 0 .566.566l1.525-.218a2.5 2.5 0 0 0 1.414-.707l5.956-5.956a1.824 1.824 0 0 0-2.58-2.58Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-add-account':
      return (
        <path
          d='M4 20c0-2.5 2-4.5 4.5-4.5h2.6m6.4 5v-5M15 18h5M15 5.2c1.7 1.7 1.7 4.4 0 6-1.7 1.6-4.4 1.7-6 0-1.6-1.7-1.7-4.4 0-6 1.7-1.6 4.3-1.6 6 0Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-add-channel':
      return (
        <path
          d='M17.006 9.003V6.83c0-.53-.211-1.04-.586-1.415l-2.83-2.829A2.001 2.001 0 0 0 12.176 2H5A2 2 0 0 0 3 4v14.007a2 2 0 0 0 2 2h4.002m8.004-13.005h-4.002a1 1 0 0 1-1-1V2m3.501 12.71v3.59m1.796-1.794h-3.59m1.794 4.502a4.502 4.502 0 1 1 0-9.005 4.502 4.502 0 0 1 0 9.005Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-location':
      return (
        <>
          <path
            clipRule='evenodd'
            d='M12 13a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            clipRule='evenodd'
            d='M12 21s-7-5.75-7-11a7 7 0 1 1 14 0c0 5.25-7 11-7 11Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-security-lock':
      return (
        <>
          <path
            clipRule='evenodd'
            d='M17 21H7a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M12 17.09V14.5M12.53 13.22a.75.75 0 1 1-1.06 1.06.75.75 0 0 1 1.06-1.06M8 9V7v0a4 4 0 0 1 4-4v0a4 4 0 0 1 4 4v2'
            fill='none'
            stroke={fill}
            strokeWidth={strokeWidth}
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </>
      );
    case 'icon-rich-text':
      return (
        <path
          d='M8.999 6.437h11.004m0 5.563H11m2 5.563h7.003M4.497 5.936a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm2 5.564a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1ZM8.5 17.063a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    case 'icon-whatsapp':
      return (
        <path
          d='M9.886 14.111c1.965 1.966 4.454 3.218 5.935 1.744l.359-.359a1.081 1.081 0 0 0-.144-1.656c-.35-.244-.726-.506-1.142-.798a1.092 1.092 0 0 0-1.393.115l-.406.403a8.686 8.686 0 0 1-1.463-1.19l-.002-.002a8.686 8.686 0 0 1-1.19-1.463l.403-.406a1.09 1.09 0 0 0 .115-1.393c-.293-.416-.555-.792-.798-1.142a1.082 1.082 0 0 0-1.656-.144l-.36.359c-1.473 1.481-.221 3.969 1.744 5.935m8.316-8.352a8.665 8.665 0 0 0-6.167-2.556c-4.807 0-8.718 3.909-8.719 8.714a8.7 8.7 0 0 0 1.163 4.357l-1.237 4.516 4.622-1.212a8.717 8.717 0 0 0 4.167 1.061h.004c4.805 0 8.716-3.91 8.718-8.715a8.662 8.662 0 0 0-2.551-6.165Z'
          fill='none'
          stroke={fill}
          strokeWidth={strokeWidth}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      );
    default:
      return <path />;
  }
};

const SVGIcon = ({
  name = '',
  style = {},
  fill = '#000',
  viewBox = '',
  size = '24',
  className = '',
  strokeWidth = 1.5,
  bgfill = 'none'
}) => (
  <svg
    width={size}
    style={style}
    height={size}
    className={className}
    xmlns='http://www.w3.org/2000/svg'
    viewBox={viewBox || getViewBox(name)}
    xmlnsXlink='http://www.w3.org/1999/xlink'>
    {getPath(name, { fill, strokeWidth, bgfill })}
  </svg>
);

export default SVGIcon;
